import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField/TextField';
import ExitPopUp from 'components/Dialogs/ThemeCustomizer/CustomizerDrawer/CustomizerOptionForm/Forms/ExitPopUp';
import ProductQuickView from 'components/Shared/ProductQuickView';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IExitPopUp } from 'interfaces/IExitPopUp';
import React, { PureComponent } from 'react';

import CouponForm from '../CouponForm';
import TimerForm from '../TimerForm';

interface IProps {
  exitPopUp?: IExitPopUp;
  classes?: any;
  enableExitPopUp: any;
  changeTitle: any;
  enableExitPopUpTime: any;
  changeTime: any;
  changeMsgButton: any;
  enableButton: any;
  onSubmit: () => void;
  onClose: any;
}

@WithStyles(theme => ({
  drawerOptions: {
    overflow: 'auto',
    animation: 'toLeft 0.3s ease-in-out 0.5s forwards',
    backgroundColor: '#fff',
    width: 448,
    '@media screen and (max-width: 960px)': {
      width: '100%'
    },
    '&::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555',
      borderRadius: 10
    }
  },
  titleClose: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20
  },
  h2: {
    fontWeight: 'bold',
    color: theme.variables.colors['primaryColor'],
    margin: 0
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #000',
    borderRadius: '100%',
    width: 40,
    height: 40,
    color: '#596375',
    fontWeight: 'bold',
    backgroundColor: '#D8D8D8',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: '#ccc'
    },
    '& svg': {
      width: '30%',
      fontWeight: 'bold',
      fill: '#596375'
    }
  },
  button: {
    fontWeight: 400,
    backgroundColor: '#009358',
    color: '#fff',
    width: '100%',
    padding: 10
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 20px'
  },
  input: {
    margin: '10px 0'
  },
  labelInput: {
    zIndex: 1,
    left: 3,
    top: 6
  },
  divider: {
    margin: '20px 0 12px 0'
  },
  exitPopUpTheme: {
    padding: '0 20px'
  },
  labelSwitch: {
    margin: '10px 0 4px -8px'
  },
  quickView: {
    margin: '0 20px'
  },
  buttonSubmit: {
    margin: 20
  }
}))
export default class SideBar extends PureComponent<IProps, any> {
  render() {
    const { classes, exitPopUp } = this.props;

    return (
      <div className={classes.drawerOptions}>
        <div className={classes.titleClose}>
          <h2 className={classes.h2}>Ativando Exit Pop Up</h2>
          <span className={classes.closeButton} onClick={this.props.onClose}>
            <SvgIcon name={'closeIcon'} />
          </span>
        </div>
        <div className={classes.quickView}>
          <ProductQuickView />
        </div>

        <div className={classes.form}>
          <FormControlLabel
            classes={{ root: classes.labelSwitch }}
            control={<Switch disableRipple checked={exitPopUp.enabled} onChange={this.props.enableExitPopUp} />}
            label={'Ativar Pop Up de Saída'}
          />

          <TextField
            className={classes.inputTitle}
            placeholder="titulo"
            disabled={!exitPopUp.timer.enabled}
            value={exitPopUp.timer.theme.title}
            label={'Título'}
            InputLabelProps={{
              classes: { root: classes.labelInput }
            }}
            onChange={this.props.changeTitle}
          />
          <div className={classes.divider}>
            <Divider />
          </div>

          <CouponForm exitPopUp={exitPopUp} />

          <div className={classes.divider}>
            <Divider />
          </div>

          <TimerForm
            enableExitPopUpTime={this.props.enableExitPopUpTime}
            exitPopUp={this.props.exitPopUp}
            changeTime={this.props.changeTime}
          />

          <div className={classes.divider}>
            <Divider />
          </div>

          <FormControlLabel
            classes={{ root: classes.labelSwitch }}
            control={
              <Switch
                disableRipple
                disabled={!exitPopUp.enabled}
                checked={exitPopUp.button.enabled}
                onChange={this.props.enableButton}
              />
            }
            label={'Ativar Botão'}
          />

          <TextField
            disabled={!exitPopUp.button.enabled}
            value={exitPopUp.button.theme.text}
            label={'Texto do botão'}
            helperText="Tamanho aceito até 100 caracteres"
            InputLabelProps={{
              classes: { root: classes.labelInput }
            }}
            InputProps={{
              inputProps: { maxlength: 100 }
            }}
            onChange={this.props.changeMsgButton}
          />
        </div>

        <div className={classes.divider}>
          <Divider />
        </div>

        <div className={classes.exitPopUpTheme}>
          <ExitPopUp exitPopUp={exitPopUp} />
        </div>

        <Grid className={classes.buttonSubmit} item xs={12}>
          <Button onClick={this.props.onSubmit} className={classes.button}>
            Salvar
          </Button>
        </Grid>
      </div>
    );
  }
}
